import { sectionNames } from "@saleor/intl";
import { CoverageTypeEnum } from "@saleor/types/globalTypes";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  CollectionListUrlQueryParams,
  CollectionListUrlSortField,
  CollectionUrlQueryParams
} from "./urls";
import CollectionCreate from "./views/CollectionCreate";
import CollectionDetailsView from "./views/CollectionDetails";
import CollectionListView from "./views/CollectionList";

const CollectionList: React.FC = () => {
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    CollectionListUrlSortField
  ) as CollectionListUrlQueryParams;
  return <CollectionListView params={params} />;
};

const CollectionDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: CollectionUrlQueryParams = qs;
  return <CollectionDetailsView id={decodeURIComponent(id)} params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.collections)} />
      <Routes>
        <Route path={""} element={<CollectionList />} />
        <Route
          path={"add"}
          element={<CollectionCreate coverageType={CoverageTypeEnum.LOCAL} />}
        />
        <Route
          path={"nationwide/add"}
          element={
            <CollectionCreate coverageType={CoverageTypeEnum.NATIONWIDE} />
          }
        />
        <Route path={":id"} element={<CollectionDetails />} />
      </Routes>
    </>
  );
};
export default Component;
